/**
 * How old a pupil must be, on a MANAGED account.
 *
 * Its own module, with no Firebase import, for one reason: every screen and
 * every test needs this number, and when it lived beside the callables the
 * only way a test could reach it was to restate it in a mock — a second copy
 * of a product rule, which drifted the moment the real one moved.
 *
 * Ten is the floor on every kind of account. A managed account exists because
 * a child cannot sign themselves in, not because there is no floor; the
 * self-signup floor sits higher still (see MIN_AGE in profileDraft.ts).
 *
 * The same numbers are enforced by functions/children.js and by the Firestore
 * rules. All three move together or a child is accepted by one and refused by
 * another.
 */
export const MIN_CHILD_AGE = 10;
export const MAX_CHILD_AGE = 25;
